import { createContext } from 'react';
import type { Lang } from '@/app/i18n/strings';

export type LangCtx = {
  lang: Lang;
  t: (key: string) => string;
  toggle: () => void;
};

export const LangContext = createContext<LangCtx | null>(null);
